export const PUBLIC_ROUTES = [
  '/auth',
  '/register',
  '/surfer-register',
  '/recover-password',
];

export const PUBLIC_ROUTES_WITH_TOKEN = ['/auth/request', '/auth/verify'];

export const AUTH_ROUTES = [
  '/auth',
  '/register',
  '/surfer-register',
  '/recover-password',
];
